<template>
  <div>
    <header-applis titre="Connaître votre projet" sous-titre="Vous y êtes presque." index-progression-courante="1"/>
    <div class="wrapper__content">
      <ul>
        <button @click="ouvrirRecherche()" class="button-app  big-button" v-show="!rechercheOuverte">Identifiez le diplôme et/ou la formation en lien avec votre projet</button>
        <button @click="ecranSuivant('choixprojet')" class="button-app  big-button" v-show="rechercheOuverte">J’ai identifié le diplôme et/ou la formation</button>
        <button @click="ecranSuivant('projetnonidentifie')" class="button-app  big-button" v-show="rechercheOuverte">Je n’ai pas identifié le diplôme et/ou la formation</button>
      </ul>
    </div>
    <footer-applis ecran-precedent="choixprojet"/>
  </div>
</template>

<script>
import HeaderApplis from '../components/HeaderApplis';
import FooterApplis from '../components/FooterApplis';

export default {
  name: 'rechercheformation',
  data() {
    return {
      rechercheOuverte: false
    }
  },
  components: {
    FooterApplis,
    HeaderApplis
  },
  computed: {
    /**
     * Récupération des informations de parcours.
     * @returns {Object} Les informations de parcours.
     */
    informationsParcours() {
      return this.$store.getters.getInformationsParcours;
    },
  },
  methods: {
    ecranSuivant(nomEcran) {
      this.$router.push(nomEcran);
    },
    ouvrirRecherche() {
      let destination = 'https://fc.univ-nantes.fr/search?l=0&beanKey=0036ab3d-49d8-4cee-866d-4a61a189991a&RH=FC&q=&types=formation&typeFo=' + this.informationsParcours.typeFormation.code + '&disc=' + this.informationsParcours.domaineFormation.code;
      window.open(destination, '_blank');
      this.rechercheOuverte = true;
    },
  }
}
</script>
